import { useContext } from "react";
import { post } from "../../../../adapters/xhr/api";
import InputElement from "../../../../shared/form/InputElement";

import stylesRequestData from "../../UnifiedTaxDeclarationRequestData/index.module.css";
import UnifiedTaxDeclarationContext from "../../../../contexts/UnifiedTaxDeclarationProvider";
import FieldRenderer from "./FieldRendrer";
import Modal from "react-modal";
import moment from "moment";

// import MultiSelectElement from "../../../shared/form/MultiSelectElement";

const DeclerationInfo = ({}) => {
  Modal.setAppElement("body");

  const unifiedTaxDeclarationContext = useContext(UnifiedTaxDeclarationContext);
  const { declarationRequest } = unifiedTaxDeclarationContext;

  const formFields = ({ declarationRequest, stylesRequestData }) => [
    {
      type: "input",
      colClass: "col-md-4",
      name: "declaration_type_text",
      labelText: "نوع الإقرار",
      labelHtmlFor: "declaration_type_text",
      inputType: "text",
      maxLength: 24,
      value: declarationRequest?.declaration_type_text,
      disabled: true,
      stylesRequestData,
      required: false,
    },
    {
      type: "input",
      colClass: "col-md-4",
      name: "status_text",
      labelText: "حالة الإقرار",
      labelHtmlFor: "status_text",
      inputType: "text",
      maxLength: 24,
      value: declarationRequest?.status_text,
      disabled: true,
      stylesRequestData,
      required: false,
    },
    {
      type: "input",
      colClass: "col-md-4",
      name: "created_at",
      labelText: "تاريخ إنشاء الإقرار",
      labelHtmlFor: "created_at",
      inputType: "text",
      maxLength: 24,
      value: moment(declarationRequest?.created_at).format("yyyy-MM-DD"),
      disabled: true,
      stylesRequestData,
      required: false,
    },
    {
      type: "input",
      colClass: "col-md-4",
      name: "submission_date",
      labelText: "تاريخ تقديم الإقرار",
      labelHtmlFor: "submission_date",
      inputType: "text",
      maxLength: 24,
      value: declarationRequest?.submission_date
        ? moment(declarationRequest?.submission_date).format("yyyy-MM-DD")
        : "-",
      disabled: true,
      stylesRequestData,
      required: false,
    },
    {
      type: "input",
      colClass: "col-md-4",
      name: "update_date",
      labelText: "تاريخ تحديث الإقرار",
      labelHtmlFor: "update_date",
      inputType: "text",
      maxLength: 24,
      value: moment(declarationRequest?.update_date).format("yyyy-MM-DD"),
      disabled: true,
      stylesRequestData,
      required: false,
    },
  ];

  const fields = formFields({
    declarationRequest,
    stylesRequestData,
  });

  return (
    <>
      {parseInt(declarationRequest?.status_id) !== 1 && (
        <div className="col-lg-4 col-sm-6">
          <InputElement
            mb4="mb-4"
            labelHtmlFor="declaration_number"
            labelClassName={`  ${stylesRequestData["form-label"]} form-label`}
            labelText="رقم الإقرار"
            inputType="text"
            maxLength={100}
            inputClassName={`${stylesRequestData["form-control"]} form-control`}
            inputID="declaration_number_input"
            name="declaration_number"
            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
            value={declarationRequest?.declaration_number || ""}
            disabled={true}
          />
        </div>
      )}

      {parseInt(declarationRequest?.status_id) === 1 && (
        <div className="col-lg-4 col-sm-6">
          <InputElement
            mb4="mb-4"
            labelHtmlFor="temp_number"
            labelClassName={`  ${stylesRequestData["form-label"]} form-label`}
            labelText="رقم الإقرار المؤقت"
            inputType="text"
            maxLength={100}
            inputClassName={`${stylesRequestData["form-control"]} form-control`}
            inputID="temp_number_input"
            name="temp_number"
            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
            value={declarationRequest?.temp_number || ""}
            disabled={true}
          />
        </div>
      )}
      {fields.map((field) => (
        <FieldRenderer key={field.name} field={field} />
      ))}
    </>
  );
};

export default DeclerationInfo;
